import Vue from 'vue'
import App from './App'
import axios from 'axios'
import qs from 'qs'
import VueRouter from 'vue-router'
import router from './router'
import 'mint-ui/lib/style.css'
import Meta from 'vue-meta'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueCookies from 'vue-cookies'
import ElementLoading from 'vue-element-loading'

// 全局注册
// 使用 UI框架
Vue.use(Vant);
Vue.use(ElementUI);
// 使用方法为:this.$axios
Vue.prototype.$axios = axios;
// 使用方法为:this.qs
Vue.prototype.qs = qs;
// 使用 VueRouter
Vue.use(VueRouter);
// 使用 Meta
Vue.use(Meta);
// 使用 VueCookies
Vue.use(VueCookies)
// 使用 VueElementLoading
Vue.component('VueElementLoading', ElementLoading)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js